import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UICloseButton from 'UIComponents/button/UICloseButton';
import H5 from 'UIComponents/elements/headings/H5';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import GoVideoContainer from './GoVideoContainer';

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error ts-migrate(7022) FIXME: 'GoVideoPopoverContent' implicitly has type 'any' ... Remove this comment to see the full error message
const GoVideoPopoverContent = ({
  isInServiceHub,
  onChange,
  onClose,
  showHeader,
  trackingHandlers,
  recipientEmail,
  isInlineVideo,
  showTitleCheckBox
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [showHeader && /*#__PURE__*/_jsxs(UIPopoverHeader, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.goVideoModal.title"
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        color: EERIE,
        size: "medium",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIPopoverBody, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          height: 378
        },
        children: /*#__PURE__*/_jsx(GoVideoContainer, {
          isInServiceHub: isInServiceHub,
          onChange: onChange,
          onClose: onClose,
          trackingHandlers: trackingHandlers,
          recipientEmail: recipientEmail,
          isInlineVideo: isInlineVideo,
          showTitleCheckBox: showTitleCheckBox
        })
      })
    })]
  });
};
GoVideoPopoverContent.propTypes = {
  isInServiceHub: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  trackingHandlers: PropTypes.object,
  recipientEmail: PropTypes.string,
  isInlineVideo: PropTypes.bool,
  showTitleCheckBox: PropTypes.bool
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
GoVideoPopoverContent.defaultProps = {
  isInServiceHub: false
};
export default GoVideoPopoverContent;